import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { bool, string, func } from 'prop-types'

class ConfirmModal extends Component {
  constructor () {
    super()

    this.handleClickYes = this.handleClickYes.bind(this)
  }
  handleClickYes () {
    let { onClickYes } = this.props
    if (this.textarea) {
      onClickYes(this.textarea.value)
    } else {
      onClickYes()
    }
  }
  render () {
    let { show, action, onClickNo } = this.props
    let hasReason = false
    let actionText
    if (action === 'playing') {
      actionText = 'ativar'
    } else if (action === 'paused') {
      actionText = 'pausar'
      hasReason = true
    }
    return (
      <Modal show={show}>
        <Modal.Body>
          {hasReason &&
          <div>
            <p>Qual o motivo da pausa?</p>
            <textarea className='form-control' ref={(textarea) => { this.textarea = textarea }} />
          </div>
          }
          {!hasReason &&
            <p className='mt20'>Tem certeza que deseja {actionText} este video?</p>
          }
        </Modal.Body>

        <Modal.Footer>
          <button className='btn btn-link' onClick={onClickNo}>Cancelar</button>
          <button className='btn btn-primary' onClick={() => { this.handleClickYes() }} style={{ textTransform: 'capitalize' }}>{actionText}</button>
        </Modal.Footer>
      </Modal>
    )
  }
}

ConfirmModal.propTypes = {
  show: bool,
  action: string,
  onClickNo: func,
  onClickYes: func
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmModal.js